import React, { useState } from 'react';
import { FileUpload } from '../../ui/FileUpload';
import { Button } from '../../ui/Button';
import { ArrowRight, ArrowLeft } from 'lucide-react';
interface RegistrationCertScreenProps {
  onNext: (file: File) => void;
  onBack: () => void;
  initialFile?: File | null;
}
export function RegistrationCertScreen({
  onNext,
  onBack,
  initialFile
}: RegistrationCertScreenProps) {
  const [file, setFile] = useState<File | null>(initialFile || null);
  return <div className="flex flex-col h-full animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-269">
      <div className="flex-1" data-id="element-270">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-271">
          Company Registration
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-272">
          Upload your official Certificate of Incorporation or equivalent
          business registration document.
        </p>

        <div className="max-w-xl" data-id="element-273">
          <FileUpload label="Registration Certificate" accept=".pdf,.jpg,.jpeg,.png" onChange={file => setFile(file)} value={file} data-id="element-274" />
        </div>
      </div>

      <div className="mt-8 flex justify-between items-center" data-id="element-275">
        <Button variant="secondary" onClick={onBack} data-id="element-276">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-277" /> Back
        </Button>
        <Button onClick={() => file && onNext(file)} disabled={!file} data-id="element-278">
          Next Step <ArrowRight className="ml-2 h-4 w-4" data-id="element-279" />
        </Button>
      </div>
    </div>;
}